import React from 'react';
import HeroCarousel from '../../components/HeroCarousel/HeroCarousel';
import ChairmanSpeech from '../../components/ChairmanSpeech/ChairmanSpeech';
import SocialResponsibility from '../../components/SocialResponsibility/SocialResponsibility';
import Specialties from '../../components/Specialties/Specialties';
import styles from './Home.module.css';

const Home = () => {
  return (
    <div className={styles.homePage}>
      <HeroCarousel />
      <ChairmanSpeech />
      <SocialResponsibility />
      <Specialties />
    </div>
  );
};

export default Home;

